import { Button, ModalBody, Modal, ModalHeader, Row, Col } from "reactstrap";
import ModalCloseIcon from "../../../../../images/modal-close.svg";
import FinSpinner from "../../../../../commonfields/FinSpinner";
import { Field, InjectedFormProps, getFormValues, reduxForm } from "redux-form";
import { connect } from "react-redux";
import "../../AdminPricingSettings.scss"
import { useState } from "react";
import { SingleSelectionBox, TextField } from "common-fields";
import {ReactComponent as Warning} from "../../../../../images/warningIcon.svg"
interface ISaveTemplateForm {
  confirmCloseModel: boolean;
  modalToggle: () => void;
  toggle: boolean;
  message:Function;
  formValues:FormData;
  tieredPricingValues:FormData;
  cancelButton:Function;
  className:string;
  loader:boolean
}

const SaveTemplateForm: React.FC<
  any & InjectedFormProps<Record<string, unknown>, any>
> = (props: any) => {
  const { toggle, modalToggle,message,formValues,tieredPricingValues,cancelButton,className } = props
  const [templateName, setTemplateName] = useState('');
  const [error, setError] = useState('');

  const typeData = [
    {
      value: 0,
      text: "Local"
    },
    {
      value: 1,
      text: "Global"
    }
  ]

  const handleSave = (values:FormData) => {
    
    if (templateName === 'Sample Template ABC') {
      setError('Template name already used, please enter a different name');
    } 
    else {
      setError('');
      cancelButton()
      modalToggle()
      message('save')
      console.log('formValues', formValues);
      console.log("tieredPricingValues",tieredPricingValues)
    }
   
  };

  const closeBtn = (
    <button
      className="close"
      onClick={modalToggle}
      type="button"
    >
      <img src={ModalCloseIcon} alt="ModalCloseIcon" />
    </button>
  );
  return (
    <Modal
      isOpen={toggle}
      className={`ToasterPopUp ${className}`}
      toggle={modalToggle}
    >
      <ModalHeader close={closeBtn}>
        Save Template
      </ModalHeader>
      <ModalBody>
        {props?.loader && <FinSpinner />}
        <form
          onSubmit={props.handleSubmit(handleSave)}
          className="saveTemplateForm"
        >
          <Row>
            <Col md={4}>
              <Field             
                component={SingleSelectionBox}
                name={"Type"}
                label={"Type:"}
                options={typeData.sort(
                  (a: any, b: any) => a.value - b.value
                )}               
              />
            </Col>
          </Row>
          <Row>
            <Col md="12" className="searchformfld">
              <Field
                component="input"
                name="templateName"
                type="text"
                className="templateName"
                autoComplete="off"
                onChange = {(e:any) => setTemplateName(e.target.value)}
                placeholder=""
              />
              <label htmlFor="templateName">Template name</label>
            </Col>
          </Row>
          <Row>
            <Col md="12">
              <Field
                name="description"
                component={TextField}
                className="description"
                type="textarea"
                placeholder="Description (optional)"
              />
            </Col>
          </Row>
          {error && <div className="error-message">
            <Warning/>
            <span>{error}</span>
            </div>}
          <div className="buttons">
            <button className="cancel-button" onClick={() => console.log('Cancel')}>Cancel</button>
            <button className="save-button" type="submit" >Save</button>
          </div>
        </form>
      </ModalBody>
    </Modal>
  );
};

const mapStateToProps = (state: any, props: any) => {
  return {
    initialValues: props.initialData,
    formValues: getFormValues("SaveTemplateForm")(state),
    tieredPricingValues:getFormValues('TieredPricingForm')(state)
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "SaveTemplateForm",
    enableReinitialize: true,
    touchOnChange: true,
  })(SaveTemplateForm)
);
